import imagesLoaded from 'imagesloaded';
import Player from '@vimeo/player';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';
import ScrollToPlugin from '../lib/ScrollToPlugin.min';
import { mosaicFunc } from './mosaic';
import { mosaicTopFunc } from './mosaic_top';
import { mosaicSingleFunc } from './mosaic_single';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// import Swiper from 'swiper/bundle';

export function main() {
	
var Module = {};
var body;

Module.Compornent = {
	mobileToggleAsset: false,
	checkClass: function($this){
		$this = null;
	}
};

(function($) {
Module.Events = (function (){
'use strict';

var OBSERVER = {
	handlers: [],
	observeEvents: function(target){
		this.handlers.push(target);
	},
	deleteListener: function(element,listener){
		element.off(listener);
		element = null;
		listener = null;
	},
	clearEvents: function(){
		$(window).off('scroll resize');
	}
};

const body = $('body');
let winH = $(window).height();
let winW = $(window).width();

let tar_offset = 120;
if(winW <= 768){
	tar_offset = 60;
}


function nav_show(){
	body.addClass('navopen');
	body.removeClass('navclose');
}
function nav_hide(){
	body.removeClass('navopen');
	body.addClass('navclose');
}
function navInit(){
	body.addClass('navclose');
	$('#nav_btn').on('click', function(){
		if( body.hasClass('navopen') ){
			nav_hide();
		}else{
			nav_show();
		}
	});
	// window.addEventListener('scroll', function(){
	// 	nav_hide();
	// });
}

function navChange(){
	nav_hide();
	const namespace = $('[data-barba="container"]').attr('data-barba-namespace');
	$('#main_nav').attr('data-namespace', namespace);
	$('#main_nav').find('a').each(function(){
		$(this).removeClass('current');
		const _a_name = $(this).attr('data-namespace');
		if( _a_name == namespace ){
			$(this).addClass('current');
		}
	});
}


function elFunc(){
	let mm = gsap.matchMedia();
	document.querySelectorAll('.el').forEach((_tar, i) => {
		if(_tar.classList.contains('el-init')) return;
		_tar.classList.add('el-init');
		
		let _elmc = _tar.querySelectorAll('.elc');
		if( _elmc.length == 0 ){
			_elmc = _tar;
		}
		gsap.set(_elmc,{ opacity:0, y:0 });
		gsap.to(_elmc,
			{ opacity:1, y:0, 
				duration: 1.2,
				ease: "power1.out",
 				stagger: 0.1,
				scrollTrigger: {
					trigger: _tar,
					start: "top bottom-=10%",
					onRefresh: self => self.progress === 1 && self.animation.progress(1),
				},
				onStart: function(){
					_tar.classList.add('elon');
				}
			}
		);
	});

	const up_scrollTrigger = ScrollTrigger.create({
		trigger: body,
		start: "top top",
		onUpdate: self => {
			const _slfscrl = self.scroll();
			if(self.direction == -1){
				document.body.classList.remove('scrldown');
			}else{
				if(_slfscrl > 10){
					if(self.prevSclrl < _slfscrl-1){
						document.body.classList.add('scrldown');
					}
					self.prevSclrl = _slfscrl;
				}
			}
			scrltop (_slfscrl);
		},
	});
	body.addClass('scrltop');
}
const scrltop = (_slfscrl) => {
	if(_slfscrl > 10){
		body.removeClass('scrltop');
		body.addClass('scrl');
	}else{
		body.removeClass('scrl');
		body.addClass('scrltop');
	}
}


async function ScrollSmootherKill() {
	await new Promise((resolve, reject) => {
		ScrollTrigger.killAll();
		resolve();
	})
}


function anchorLink(){
	$('a.anchor').on('click', function(e){
		e.preventDefault();
		// e.stopPropagation();
		nav_hide();
		let hrefPageUrl = $(this).prop("href");
		hrefPageUrl = hrefPageUrl.split("#")[0];
		let currentUrl = location.href;
		currentUrl = currentUrl.split("#")[0];
		if( hrefPageUrl == currentUrl ){
			let href = this.hash;
			gsap.to(window, { duration:0.6, scrollTo:{y:href, autoKill:false, offsetY:tar_offset}, ease:'power2'});	
		}
	});
}


const contact_Cf7 = () => {
	if (wpcf7 && typeof wpcf7.init === 'function') { 
		document.querySelectorAll( '.wpcf7 > form' ).forEach( function( form ) {
			wpcf7.init( form );
		});
	}
}

function expandFunc() {
	const expand = (parent, state) => {
		if(state){
			parent.classList.add('open');
		}else{
			parent.classList.remove('open');
		}
		const exc = parent.querySelector('.exc');
		gsap.utils.toArray(exc).forEach(ex => {
			gsap.to(ex,{
				height: (!state) ? 0 : "auto",
				duration:0.3,
				ease: "power2.inOut",
				onComplete: () => {
					ScrollTrigger.refresh();
				}
			});
		});
	}
	const expand_event = (e) => {
		let parent = e.target.closest('.ex');
		const result = parent.classList.contains('open');
		if (result) {
			expand(parent, false);
		}else{
			expand(parent, true);
		}
	};
	gsap.utils.toArray('.exbtn').forEach(exbtn => {
		let parent = exbtn.closest('.ex');
		expand(parent, false);
		exbtn.removeEventListener('click',expand_event);
		exbtn.addEventListener('click',expand_event);
	});
}


function infiniteScrollInit(){
	const container = document.querySelector('.infinite-scroll-container');
	if (!container) return;

	// barba遷移のたびに呼ばれるため、同じコンテナへの多重バインドを防ぐ
	if (container.dataset.scrollBound) return;
	container.dataset.scrollBound = '1';

	const loader = document.getElementById('infinite_scroll_loader');
	let isLoading = false;
	const MAX_RETRIES = 3;

	const loadMorePosts = (retryCount = 0) => {
		if (isLoading) return;

		const currentPage = parseInt(container.dataset.page);
		const maxPages = parseInt(container.dataset.maxPages);

		if (currentPage >= maxPages) return;

		isLoading = true;
		loader.style.display = 'block';

		const formData = new FormData();
		formData.append('action', 'load_more_posts');
		formData.append('page', currentPage + 1);
		formData.append('post_type', container.dataset.postType || 'post');
		formData.append('posts_per_page', parseInt(container.dataset.postsPerPage) || 6);
		formData.append('template_part', container.dataset.templatePart || '');
		formData.append('nonce', infiniteScrollData.nonce);
		formData.append('lang', container.dataset.lang || '');

		const taxonomy = container.dataset.taxonomy;
		const term = container.dataset.term;

		if (taxonomy && term) {
			formData.append('taxonomy', taxonomy);
			formData.append('term', term);
		}

		fetch(infiniteScrollData.ajax_url, {
			method: 'POST',
			body: formData
		})
		.then(response => {
			if (!response.ok) {
				const error = new Error(`HTTP error! status: ${response.status}`);
				error.status = response.status;
				throw error;
			}
			return response.json();
		})
		.then(data => {
			if (data.success && data.data && data.data.html) {
				if (data.data.html.trim() !== '') {
					container.insertAdjacentHTML('beforeend', data.data.html);
					container.dataset.page = data.data.current_page;

					setTimeout(() => {
						elFunc();
						vimeoInitFunc();
						ScrollTrigger.refresh();
					}, 100);
				}
			}
			loader.style.display = 'none';
			isLoading = false;
		})
		.catch((error) => {
			// ネットワークエラーの場合のみリトライ（HTTPステータスエラーはリトライしない）
			const isNetworkError = !error.status;

			if (isNetworkError && retryCount < MAX_RETRIES) {
				const retryDelay = Math.pow(2, retryCount) * 1000; // 1秒, 2秒, 4秒
				setTimeout(() => {
					isLoading = false;
					loadMorePosts(retryCount + 1);
				}, retryDelay);
			} else {
				loader.style.display = 'none';
				isLoading = false;
			}
		});
	};

	const checkScroll = () => {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;

		if (scrollTop + windowHeight > documentHeight - 300) {
			loadMorePosts();
		}
	};

	window.addEventListener('scroll', checkScroll);
}

function parallax_img() {
  const paraimg = document.querySelectorAll('.paraimg');
  if (paraimg.length) {
    paraimg.forEach(el => {
      let img = el.querySelector('img');
      if (!img) {
        img = el.querySelector('.iframe_wrap');
      }
      if (img) {
        gsap.fromTo(img,
          { y: 0 },
          {
            y: () => -(img.offsetHeight - el.offsetHeight),
            ease: 'none',
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
							invalidateOnRefresh: true,
            },
          }
        );
      }
    });
  }
}


// 再生位置が実際に進み始めたら一度だけcallbackを呼ぶ（play()解決時点ではまだ描画されていないことがある）
function onStarted(player, callback){
  const onTime = ({ seconds }) => {
    if (seconds <= 0) return;
    player.off('timeupdate', onTime);
    callback();
  };
  player.on('timeupdate', onTime);
}

// holderの中央に再生ボタンを出す
function showPlayButton(holder, onClick){
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'autoplay_btn';
  btn.setAttribute('aria-label', document.documentElement.lang.indexOf('ja') === 0 ? '動画を再生' : 'Play video');
  btn.innerHTML = '<img src="' + infiniteScrollData.theme_url + '/img/play.svg" alt="">';
  btn.addEventListener('click', onClick);
  holder.appendChild(btn);
  return btn;
}
function hidePlayButton(btn){
  if (!btn) return;
  btn.classList.add('is_hide');
  btn.addEventListener('transitionend', () => btn.remove(), { once: true });
}

// 自動再生できない時（iOSの低電力モードなど）に、holderの中央へ再生ボタンを出す
// play()の失敗、または3秒経っても再生位置が進まない場合に表示。onClick省略時はplayer.play()
function autoplayFallback(player, holder, onClick){
  let started = false;
  let btn = null;

  const showBtn = () => {
    if (started || btn || !document.contains(holder)) return;
    btn = showPlayButton(holder, () => {
      if (onClick) onClick();
      else player.play().catch(() => {});
    });
  };

  onStarted(player, () => {
    started = true;
    hidePlayButton(btn);
  });

  player.ready().then(() => player.play()).catch(showBtn);
  setTimeout(showBtn, 3000);
}

// 音ありの動画プレイヤー（トップKVの音をONにした時に止める対象）
const soundPlayers = new Set();
function pauseSoundPlayers(){
  soundPlayers.forEach(item => {
    // ページ遷移で無くなった動画は対象から外す
    if (!document.contains(item.wrap)) {
      soundPlayers.delete(item);
      return;
    }
    item.player.pause().catch(() => {});
  });
}

// Vimeo動画の共通初期化
// PHPは [data-vimeo="ID"] の枠だけを出力し、プレイヤーはここで生成する
// オプション
//   data-vimeo="ID1,ID2" : 複数指定すると終了ごとに切り替えてループ（autoplay時のみ）
//   data-autoplay="1"    : 無音の自動再生（background）。再生できない時は再生ボタンを出す
//   data-random="1"      : 複数指定時、最初に再生する動画をランダムにする
//   data-volume="要素ID"  : 音のON/OFFボタン。他の動画が再生されたらミュートに戻す
//   子要素 .img.poster    : autoplay時は再生が進み始めたら消す／それ以外はクリックで読み込んで再生
//   autoplayなし          : 音ありのプレイヤー（操作パネル付き）
function vimeoInitFunc(){
  document.querySelectorAll('[data-vimeo]').forEach(wrap => {
    if (wrap.dataset.vimeoBound) return;
    wrap.dataset.vimeoBound = '1';

    if (wrap.dataset.autoplay === '1') {
      autoplayVideo(wrap);
      return;
    }

    const poster = wrap.querySelector('.img.poster');
    const createPlayer = (options) => {
      const player = new Player(wrap, Object.assign({ id: wrap.dataset.vimeo, loop: true, muted: false }, options));
      soundPlayers.add({ wrap, player });
      notifyPlay(player, wrap);
      return player;
    };

    if (poster) {
      // クリックされるまでプレイヤーを読み込まない
      poster.addEventListener('click', () => {
        hidePoster(wrap);
        createPlayer({ autoplay: true });
      }, { once: true });
    } else {
      createPlayer();
    }
  });
}

// 再生されたら他の動画に知らせる（音のON/OFFボタンを持つ動画はミュートに戻す）
function notifyPlay(player, wrap){
  player.on('play', () => {
    document.dispatchEvent(new CustomEvent('vimeo:play', { detail: { wrap } }));
  });
}

function hidePoster(wrap){
  const poster = wrap.querySelector('.img.poster');
  if (!poster) return;
  wrap.classList.add('playing');
  poster.addEventListener('transitionend', () => poster.remove(), { once: true });
}

// iPhone/iPad（iPadOSはMac表記のため、タッチ対応で判定）
const IS_IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

// 自動再生（background）。IDが複数あれば終了ごとに次の動画へ差し替えてループする
// プレイヤーは1つだけ使い、loadVideoで差し替える
function autoplayVideo(wrap){
  const ids = wrap.dataset.vimeo.split(',').filter(Boolean);
  const multi = ids.length > 1;
  const volumeBtn = wrap.dataset.volume ? document.getElementById(wrap.dataset.volume) : null;
  const holder = wrap.closest('#kv, .paraimg') || wrap;
  let current = (multi && wrap.dataset.random === '1') ? Math.floor(Math.random() * ids.length) : 0;
  let switching = false;
  let muted = true;
  let realDuration = 0;
  let playedSeconds = 0;
  let btn = null;

  const el = document.createElement('div');
  el.className = 'vimeo_player';
  wrap.appendChild(el);
  const player = new Player(el, {
    id: ids[current],
    background: true,
    muted: true,
    loop: !multi,
    autoplay: true,
    // 他のVimeo動画が再生された時に、この動画が一時停止されないようにする
    autopause: false,
  });
  notifyPlay(player, wrap);

  // 再生ボタン（自動再生や再開ができない時。iOSの低電力モードなど）。再生が進み始めたら消す
  const showButton = () => {
    if (btn) return;
    btn = showPlayButton(holder, () => {
      player.setMuted(muted).catch(() => {});
      player.play().catch(() => {});
    });
    onStarted(player, () => {
      hidePlayButton(btn);
      btn = null;
    });
  };

  const muteFnc = (value) => {
    muted = value;
    player.setMuted(muted).catch(() => {});
    if (volumeBtn) volumeBtn.querySelector('span').textContent = muted ? 'OFF' : 'ON';
  };

  // 次の動画へ差し替える。再生できなければ再生ボタンを出す
  const next = () => {
    if (switching) return;
    switching = true;
    // iOSは差し替えた動画の音を操作なしでONにできないため、表示をOFFに戻す（再度ONで音が出る）
    if (IS_IOS && !muted) muteFnc(true);
    current = (current + 1) % ids.length;
    realDuration = 0;
    player.loadVideo({ id: ids[current], background: true, loop: false, autopause: false })
      .then(() => {
        // iOSの低電力モードではplay()が失敗せずに止まったままになることがあるため、3秒進まなければボタンを出す
        const timer = setTimeout(showButton, 3000);
        onStarted(player, () => {
          clearTimeout(timer);
          switching = false;
        });
        player.getDuration().then(d => { realDuration = d || 0; }).catch(() => {});
        return player.setMuted(muted).then(() => player.play());
      })
      .catch(() => {
        switching = false;
        showButton();
      });
  };

  player.ready().then(() => player.getDuration()).then(d => { realDuration = d || 0; }).catch(() => {});

  if (multi) {
    // iOS(低電力モードからの手動再生など)では再生直後のdurationやendedが不正確なことがあるため、
    // 動画本来の長さを取得し、実際に終盤まで再生した時だけ切り替える
    const isNearEnd = (seconds) => realDuration > 0 && seconds >= realDuration - 0.3;
    player.on('timeupdate', ({ seconds }) => {
      playedSeconds = seconds;
      if (!switching && isNearEnd(seconds)) next();
    });
    player.on('ended', () => {
      if (!switching && isNearEnd(playedSeconds + 1)) next();
    });
  }

  // 音のON/OFFがある動画は、他の動画の再生などで止められたら再開する
  if (volumeBtn) {
    player.on('pause', () => {
      if (switching || btn) return;
      if (!document.contains(wrap) || document.visibilityState !== 'visible') return;
      // iOSは操作なしで再開すると無音になるため、表示をOFFに戻す（スクロールで画面外に出た時など）
      if (IS_IOS && !muted) muteFnc(true);
      player.getEnded().then(ended => {
        if (ended) return;
        return player.play().then(() => player.setMuted(muted));
      }).catch(showButton);
    });
  }

  onStarted(player, () => {
    wrap.classList.add('is_started');
    hidePoster(wrap);
  });

  // 自動再生できない場合（iOSの低電力モードなど）は再生ボタンを出す
  autoplayFallback(player, holder, () => {
    player.setMuted(muted).catch(() => {});
    player.play().catch(() => {});
  });

  if (volumeBtn) {
    volumeBtn.addEventListener('click', () => {
      muteFnc(!muted);
      if (!muted) {
        // 音をONにしたら、再生中の他の動画（音あり）を止める
        pauseSoundPlayers();
        player.play().catch(() => {});
      }
    });
    // 他の動画が再生されたらミュートに戻す（ページ遷移後は解除）
    const onOtherPlay = (e) => {
      if (!document.contains(wrap)) {
        document.removeEventListener('vimeo:play', onOtherPlay);
        return;
      }
      if (e.detail && e.detail.wrap === wrap) return;
      muteFnc(true);
    };
    document.addEventListener('vimeo:play', onOtherPlay);
  }
}

function googlemapFunc(){
  let map;
  let center =  { lat: 35.631117, lng: 139.900645 };
  async function initMap() {
    await google.maps.importLibrary("maps");
    await google.maps.importLibrary("marker");
    map = new google.maps.Map(document.getElementById("map"), {
      center,
      zoom: 14,
      mapId: "259a4b1b5b78b8b471592870",
    });
    addMarker();
  }
  async function addMarker() {
		const markerSize = window.matchMedia('(max-width: 767px)').matches ? 36 : 54;
    const locations = [
      { position: { lat: 35.629814154506384, lng: 139.90628075145088 }, title: "本社工場" },
      { position: { lat: 35.63362979989619, lng: 139.89385736441773 }, title: "浦安工場" },
    ];
    locations.forEach(({ position, title }) => {
      const container = document.createElement('div');
      container.style.cssText = 'display:flex;flex-direction:column;align-items:center;transform:translateY(50%);';
      const img = document.createElement('img');
      img.src = infiniteScrollData.theme_url + '/img/marker.svg';
      img.width = markerSize;
      img.style.cssText = `width:${markerSize}px;height:auto;`;
      const label = document.createElement('span');
      label.textContent = title;
      label.style.cssText = 'margin-top:4px;font-size:12px;font-weight:bold;text-align:center;white-space:nowrap;';
      container.appendChild(img);
      container.appendChild(label);
      new google.maps.marker.AdvancedMarkerElement({
        map,
        position,
        title,
        content: container,
      });
    });
  }
  initMap();
}

function languageSwitcher() {
  const userLang = navigator.language || navigator.userLanguage;
  const bogoSwitcher = document.querySelector('.bogo-language-switcher');
  if (!bogoSwitcher) return;

  const currentItem = bogoSwitcher.querySelector('li.current');
  if (!currentItem) return;

  const isCurrentEn = currentItem.classList.contains('en');
  const isCurrentJa = currentItem.classList.contains('ja');

  if (userLang.startsWith('en') && !isCurrentEn) {
    const enLink = bogoSwitcher.querySelector('a[href*="/en/"]');
    if (enLink) {
      window.location.href = enLink.href;
    }
  } else if (userLang.startsWith('ja') && !isCurrentJa) {
    const jaLink = Array.from(bogoSwitcher.querySelectorAll('a')).find(a => !a.href.includes('/en/'));
    if (jaLink) {
      window.location.href = jaLink.href;
    }
  }
}

var PageEvents = {
	loadFunc: function(){
		navInit();
	},
	commonFunc: function(){
		this.pjaxReadyFunc();
		winH = $(window).height();
		winW = $(window).width();	
		anchorLink();
		navChange();
		elFunc();
		expandFunc();
		infiniteScrollInit();
    parallax_img();
    vimeoInitFunc();
		OBSERVER.observeEvents(1);
	},
	pjaxReadyFunc: function(){
	},
  topFunc: async function(){
    body.addClass('top');
    mosaicTopFunc();
  },
  blanking_pressFunc: async function(){
    mosaicSingleFunc();
  },
  jobFunc: async function(){
    mosaicFunc();
  },
  contactFunc: async function(){
    googlemapFunc();
  },
};

const replaceBogo = function(data){
	let target = '#wrapper';
	if(data){
		target = data.next.html;
	}
	const $newPageBogo = $(target).find('.bogo-language-switcher').html();
	const bogo = document.getElementById('bogo');
	bogo.innerHTML = $newPageBogo;
	bogo.querySelectorAll('a').forEach(a => {
		a.classList.add('nopj');
	});
}

function pjaxSettings(){

	barba.use(barbaPrefetch);

  replaceBogo();

	const replaceHead = function(data){
		const head = document.head;
		const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
		const newPageHead = document.createElement('head');
		newPageHead.innerHTML = newPageRawHead;
		const removeHeadTags = [ 
			"meta[name='keywords']"
			,"meta[name='description']"
			,"meta[property^='og']"
			,"meta[name^='twitter']"
			,"meta[itemprop]"
			,"link[itemprop]"
			,"link[rel='prev']"
			,"link[rel='next']"
			,"link[rel='canonical']"
      ,"style"
		].join(',');
		const headTags = head.querySelectorAll(removeHeadTags)
		for(let i = 0; i < headTags.length; i++ ){
			head.removeChild(headTags[i]);
		}
		const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)
		for(let i = 0; i < newHeadTags.length; i++ ){
			head.appendChild(newHeadTags[i]);
		}
	}

	var eventDelete = function eventDelete(e) {
		if (e.currentTarget.href === window.location.href) {
			e.preventDefault()
			e.stopPropagation()
			return
		}
	}
	const links = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
		links.forEach(function (link) {
			link.addEventListener('click', function (e) {
			eventDelete(e)
		}, false)
	})

	var gaPush = function gaPush(pagename) {
		if (typeof ga === 'function' && Barba.HistoryManager.history.length >= 1) {
			ga('send', 'pageview', pagename);
		}
		if (typeof gtag === 'function' && Barba.HistoryManager.history.length >= 1) { 
			// gtag('config', 'G-Xxxxxxxx', {'page_path': pagename}); 
		}
	}

	var preventSettings = function preventSettings(el) {
		let href = el.getAttribute('href');
		if (href == null) {
				href = el.getAttribute('xlink:href');
		}
		if (el.classList.contains('pj')) {
			return false;
		}
		if (el.classList.contains('nopj')) {
				return true;
		}
		let site_url = location.protocol + '//' + location.host;
		if (!href.startsWith(site_url)) {
				el.setAttribute('target', '_blank');
				return true;
		}
		let url = location.protocol + '//' + location.host + location.pathname;
		let extract_hash = href.replace(/#.*$/, "");
		if (href.startsWith(location.protocol + '//' + location.host)) {
				if (href.indexOf('#') > -1 && extract_hash == url) {
						return false;
				}
		}
		if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(href.toLowerCase())) {
				el.setAttribute('target', '_blank');
				return true;
		}
		return false;
	}

	async function scroll(data) {
		await new Promise((resolve, reject) => {
			let scrltarget = 0;
			if(data.trigger === "back") {
				scrltarget = scrollPosY;
			}
			scrollPosY = barba.history.current.scroll.y;
			if(data.trigger === "forward"){
				scrltarget = scrollForwardPosY;
			}

			if(location.hash){
				var anchor = document.querySelector( location.hash );
				if(anchor){
					var target = location.hash;
					gsap.to(window, { duration:0, scrollTo:{y:target, autoKill:false, offsetY:tar_offset}, ease:'power2', onComplete:function(){
						body.addClass('scrldown');
						resolve();
					}});	
				}else{
					gsap.to(window, { duration:0, scrollTo:0, ease:'power2', onComplete:function(){
						resolve();
					}});
				}
			}else{
				gsap.to(window, { duration:0, scrollTo:scrltarget, ease:'power2', onComplete:function(){
					body.removeClass('scrldown');
					resolve();
				}});
			}
		})
	}


	barba.init({
		prevent: function prevent(_ref) {
			var el = _ref.el;
			return preventSettings(el);
		},
		timeout: 10000,			
		transitions: [{
			name: 'transition',
			sync:true,
			leave:function(data) {
				const done = this.async();
				gsap.to('#footer', {opacity:0, duration:0.2})
				gsap.to(data.current.container, {opacity:0, duration:0.2, onComplete:function(){
					ScrollSmootherKill();
					done();
				}});
			},
			enter:function(data) {
				const done = this.async();
				const $elm = $(data.next.container);
				$elm.css({'opacity':0});
				done();
			}
		}]
	})

	barba.hooks.beforeLeave(() => {
		body.removeClass('ready top inpage navopen scrldown scrltop scrl');
	});

	barba.hooks.beforeEnter((data) => {
		replaceHead(data);
		replaceBogo(data);
		if( OBSERVER.handlers.length ){
			OBSERVER.clearEvents();
		}
		gaPush(location.pathname);
	});

	var scrollPosY = 0;
	var scrollForwardPosY = 0;
	barba.hooks.leave((data) => {
		scrollForwardPosY = data.current.container.scroll.y;
	});

	barba.hooks.after((data) => {
		async function callerFun(){
			pageCheck();
  		scroll(data);
			if( document.getElementById('form_blc') ){
				contact_Cf7();
			}	
			gsap.to('footer', {opacity:1, duration:0.6})
			gsap.to(data.next.container, {opacity:1, duration:0.6, onStart:function(){
			}});
		}
		$('#container').imagesLoaded( function() {
			callerFun();
		});
	});
}

async function pageCheck() {
	await new Promise((resolve, reject) => {
		PageEvents.commonFunc();

		if( document.getElementById('top') ){
			PageEvents.topFunc();
		}else{
			body.addClass('inpage');
		}
    if( document.getElementById('blanking-press') ){
      PageEvents.blanking_pressFunc();
    }
    if( document.getElementById('job') ){
      PageEvents.jobFunc();
    }
    if( document.getElementById('contact') ){
      PageEvents.contactFunc();
    }
		body.addClass('ready');
		resolve();
	})
}

function initialize(){
	window.addEventListener('DOMContentLoaded', function(){
		PageEvents.loadFunc();
		pageCheck();
		pjaxSettings();
	});
	window.addEventListener('load', function(){
		body.addClass('siteloaded');
	});
}

initialize();

})();
})( jQuery );

}
